import type { MultilinkStoryblok } from "../../component-types-sb";

export type ResolvedLink = {
  href: string;
  target?: "_blank";
};

export function resolveLink(link: MultilinkStoryblok): ResolvedLink {
  if (link.linktype === "story") {
    // cached_url is soms niet het volledige pad (bv. "lezing02" i.p.v.
    // "lezingen/lezing02") als de link zonder folder-context is opgeslagen.
    // Met resolve_links=url op de story-fetch geeft Storyblok het volledige
    // pad via story.full_slug — die heeft dus voorrang. Ook hier kan een
    // trailing slash voorkomen (folder-index stories), die onze routes nooit
    // hebben.
    const slug = (link.story?.full_slug ?? link.cached_url ?? "").replace(
      /\/+$/,
      ""
    );
    return { href: `/${slug}` };
  }
  if (link.linktype === "email") {
    return { href: `mailto:${link.email ?? ""}` };
  }
  return { href: link.url ?? link.cached_url ?? "", target: "_blank" };
}
